/* Groups rows by rate in defaultRows' response order, Default row before a
 * rate's conditional bands. conditionalRows is expected to already be in
 * band order (e.g. sorted by lower bound); grouping preserves that order.
 */
export function sortDynamicRateRangeRows<
  Row extends { isDefault: boolean; rate: string },
>(defaultRows: Row[], conditionalRows: Row[]): Row[] {
  const groups = new Map<string, Row[]>();

  const addRow = (row: Row): void => {
    const group = groups.get(row.rate);

    if (group) {
      group.push(row);
    } else {
      groups.set(row.rate, [row]);
    }
  };

  defaultRows.forEach(addRow);
  conditionalRows.forEach(addRow);

  return [...groups.values()].flat();
}
